import { Link } from "react-router-dom";
import { Sparkles, Mail, MapPin } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[#1E293B] bg-[#0B0F1A] mt-20"
    >
      <div className="container-7 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Link to="/" className="flex items-center gap-2" data-testid="footer-brand-link">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-[#4DA3FF]/15 border border-[#4DA3FF]/30">
              <Sparkles className="h-4 w-4 text-[#4DA3FF]" strokeWidth={1.8} />
            </span>
            <span className="font-display text-[17px] font-medium tracking-tight">
              WebAura<span className="text-[#4DA3FF]">Sites</span>
            </span>
          </Link>
          <p className="mt-5 text-[#94A3B8] text-sm leading-relaxed max-w-md">
            A UK-based web design studio building modern, fast, conversion-focused
            websites for ambitious small businesses and growing brands.
          </p>
          <div className="mt-6 space-y-2 text-sm text-[#94A3B8]">
            <a
              href="mailto:hello@webaurasites.co.uk"
              data-testid="footer-email-link"
              className="flex items-center gap-2 hover:text-white transition-colors"
            >
              <Mail size={14} className="text-[#4DA3FF]" />
              hello@webaurasites.co.uk
            </a>
            <p className="flex items-center gap-2">
              <MapPin size={14} className="text-[#4DA3FF]" />
              United Kingdom · Working remotely worldwide
            </p>
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-sm font-medium text-white mb-4">Pages</h4>
          <ul className="space-y-2 text-sm text-[#94A3B8]">
            {[
              { to: "/", label: "Home" },
              { to: "/services", label: "Services" },
              { to: "/about", label: "About" },
              { to: "/contact", label: "Contact" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-sm font-medium text-white mb-4">Ready to start?</h4>
          <p className="text-sm text-[#94A3B8] mb-4">
            Most websites are designed, built and launched in 3–6 days.
          </p>
          <Link to="/contact" className="btn-primary text-sm" data-testid="footer-cta-button">
            Book a free consultation
          </Link>
        </div>
      </div>

      <div className="border-t border-[#1E293B]">
        <div className="container-7 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#64748B]">
          <p data-testid="footer-copyright">
            © {year} WebAuraSites. All rights reserved.
          </p>
          <p>Designed &amp; built in the UK · Crafted with care</p>
        </div>
      </div>
    </footer>
  );
}
